var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vp-compare__row",class:_vm.rowClass,on:{"click":function($event){if($event.target !== $event.currentTarget)return null;$event.stopPropagation();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }